<script>

export default {
  name: "InputFieldComponent",
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
      required: true
    },
    validationError: {
      type: Array,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    errMessage() {
      return this.validationError?.length ? this.validationError[0] : null
    }
  }
}
</script>

<template>
  <div :class="['row mb-3']">
    <label v-if="label" :class="['col-2 col-form-label', { 'required': required }]" :for="label">{{ label }}</label>
    <div class="col-10">
      <input
          :type="type"
          :id="label"
          class="form-control"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          :placeholder="placeholder"
          autocomplete="off"
      />
      <slot></slot>
      <small class="has_error" v-if="validationError">{{ errMessage }}</small>
    </div>
  </div>
</template>

<style scoped>
.has_error{
  color: red;
}
</style>